import axiosInstance from "../../services/axios";
import { ActionTypes } from "../type";
import { EndPoints } from "../../settings/endpoints";

export const getZoneList = () => async (dispatch) => {
  try {
    const employee_code_id = Number(localStorage.getItem("employee_code_id"));

    // const zone_id = Number(localStorage.getItem("zone_id"));
    // const f_is_franchise_employee = Number(
    //   localStorage.getItem("is_franchise_employee")
    // );
    // const f_franchise_id = Number(localStorage.getItem("franchise_id"));
    // const f_is_super_franchise = Number(localStorage.getItem("is_super_franchise"));
    // let params = {
    //   zone_id,
    // };

    // if (f_is_franchise_employee === 1 || f_is_super_franchise === 1) {
    // params = {
    //   ...params,
    //   f_is_franchise_employee,
    //   f_franchise_id,
    //   f_is_super_franchise,
    //   employee_code_id
    // };
    // }
    const response = await axiosInstance.get(
      EndPoints.EMPLOYEEALLOCATE.LIST + `/${employee_code_id}`
    );
    const { data } = response;
    dispatch({
      type: ActionTypes.ZONE,
      payload: data,
    });
  } catch (err) {
    throw err;
  }
};
